<template>
	<div class="login_top">
		<div class="pop_close" :class="{ 'pop_close_ipad': topShow }"
			style="justify-content: flex-start; margin-bottom: 1.55rem;" v-if="loginType == 2 || loginType == 3">
			<img @click="exchange" src="@/assets/image/icon/arrow_left.png" class="img1">
		</div>
		<div v-else>
			<div class="pop_close" :class="{ 'pop_close_ipad': topShow }" style="justify-content: flex-end;">
				<img @click="Close" src="@/assets/image/icon/yjdlclose.png" class="img2">
			</div>
			<div class="logo">
				<div class="logo_wrap">
					<div class="logo_img">
						<img src="@/assets/image/logo/logo.png">
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LoginTop',
	data() {
		return {}
	},
	props: {
		loginType: {
			type: Number,
			default: 0
		},
		topShow: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		Close() {
			this.$emit("tonumberClose")
		},
		exchange() {
			this.$emit("exchange", 1)
		}
	}
}
</script>

<style lang="scss" scoped>
.login_top {
	width: 100%;

	.pop_close {
		width: 100%;
		display: flex;
		margin-bottom: 0.5rem;
		margin-top: 1.55rem;

		.img1 {
			display: block;
			width: 0.4rem;
			height: 0.675rem;
			margin-left: 0.5rem;
			cursor: pointer;
		}

		.img2 {
			display: block;
			width: 0.7rem;
			height: 0.7rem;
			margin-right: 1.3rem;
			cursor: pointer;
		}
	}

	.logo {
		display: flex;
		flex-direction: column;
		padding-bottom: 1.5rem;

		.logo_wrap {
			display: flex;
			align-items: center;
			margin-left: 1.9rem;

			.logo_img {
				width: 8.25rem;
				height: 2.1rem;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.logo_title {
				margin-left: 0.725rem;

				.title {
					font-weight: bold;
					font-size: 1rem;
					color: #8E703A;
					padding-bottom: 0.65rem;
				}

				.slogan {
					font-size: 0.7rem;
					color: #C1A673;
				}
			}
		}
	}
}
</style>